"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _glReact = require("gl-react");

var _disposable = require("gl-react/lib/helpers/disposable");

var _glTexture2d = require("gl-texture2d");

var _glTexture2d2 = _interopRequireDefault(_glTexture2d);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function loadImage(src, success, failure) {
  var img = new window.Image();
  if (src.slice(0, 5) !== "data:") {
    img.crossOrigin = true;
  }
  img.onload = function () {
    if (img) {
      success(img);
    }
    img = null;
  };
  img.onabort = img.onerror = failure;
  img.src = src;
  return function () {
    if (img) {
      img.onload = null;
      img.onerror = null;
      img.onabort = null;
      img.src = "";
      img = null;
    }
  };
}

var ImageTextureLoader = function (_TextureLoader) {
  _inherits(ImageTextureLoader, _TextureLoader);

  function ImageTextureLoader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ImageTextureLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ImageTextureLoader.__proto__ || Object.getPrototypeOf(ImageTextureLoader)).call.apply(_ref, [this].concat(args))), _this), _this.loads = {}, _this.textures = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ImageTextureLoader, [{
    key: "dispose",
    value: function dispose() {
      (0, _disposable.disposeObjectMap)(this.loads);
      (0, _disposable.disposeObjectMap)(this.textures);
    }
  }, {
    key: "canLoad",
    value: function canLoad(input) {
      return typeof input === "string";
    }
  }, {
    key: "load",
    value: function load(input) {
      var _this2 = this;

      var src = input;
      if (src in this.loads) {
        return this.loads[src];
      }
      var dispose = function dispose() {};
      var promise = new Promise(function (success, failure) {
        return dispose = loadImage(src, success, failure);
      }).then(function (img) {
        var gl = _this2.gl;

        var texture = (0, _glTexture2d2.default)(gl, [img.width, img.height]);
        texture.setPixels(img);
        _this2.textures[src] = texture;
        delete _this2.loads[src];
        return texture;
      });
      var d = { promise: promise, dispose: dispose };
      this.loads[src] = d;
      return d;
    }
  }, {
    key: "get",
    value: function get(input) {
      return this.textures[input];
    }
  }]);

  return ImageTextureLoader;
}(_glReact.TextureLoader);

exports.default = ImageTextureLoader;
//# sourceMappingURL=ImageTextureLoader.js.map


//////////////////
// WEBPACK FOOTER
// ./~/gl-react-dom/lib/ImageTextureLoader.js
// module id = 74
// module chunks = 0